import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'
import { Validator } from '@sequencehq/utils/validation'
import { GRANT_PRICE_VALIDATORS } from 'CreditGrants/index'

export type CreditGrantFormValues = {
  name: string
  amount: string
  hasDiscountedPrice: boolean
  costOfCredit: string
  grantRefreshFrequency: Dashboardv99990101Api.CreditGrants.GrantRefreshFrequency
  billingFrequency: Dashboardv99990101Api.CreditGrants.GrantBillingFrequency
}

// Validators receive the whole form as `object`; narrow it once here.
const asFormValues = (allValues?: object) =>
  allValues as CreditGrantFormValues | undefined

// The price field is only rendered when the discount checkbox is on, so its
// validators must be inert otherwise — an error on a hidden field blocks submit
// with nothing to show the merchant.
const onlyWhenDiscounted =
  (validator: Validator): Validator =>
  (value, allValues) =>
    asFormValues(allValues)?.hasDiscountedPrice
      ? validator(value, allValues)
      : undefined

export const DISCOUNTED_PRICE_VALIDATORS: Validator[] =
  GRANT_PRICE_VALIDATORS.map(onlyWhenDiscounted)
